module.exports = __webpack_public_path__ + "media/images/contractor-111-f9c0e3b9c1aa91a12e30554c6c022aea.jpg";